





































































import Draggable from 'vuedraggable';
import { IProductSize } from '@/services/product/types';
import { GridColumn, GridTable } from '@/components/grid';
import ShowGuide from '@/components/ShowGuide.vue';

export default {
  props: {
    readOnly: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    localColumns: {
      // get/set reordered columns
      get(): string[] {
        return this.value[0];
      },
      set(columnHeaders: string[]) {
        this.$emit('input', [
          columnHeaders,
          ...this.value.slice(1),
        ]);
      },
    },
    localValue: {
      get(): IProductSize[] {
        return this.value;
      },
      set(value: IProductSize[]) {
        if (value.length === 1) {
          const isAddAction = value.length > this.value.length;
          if (isAddAction) {
            // user adding new row so copy header row and make blank
            const blankRow = [value[0].map(v => '')];
            value = value.concat(blankRow);
          } else {
            // user removing last row so remove header too
            value = [];
          }
        }
        this.$emit('input', value);
      },
    },
    shape() {
      return this.value.length
        ? this.value[0].map(() => '')
        // default columns
        : ['Title', 'S', 'M', 'L', 'XL'];
    },
  },
  methods: {
    columnSize(index: number) {
      // Ensure first column is always largest to fill space
      if (index === 0) {
        const [firstRow] = this.value;
        return 13 - firstRow.length;
      }
      return 1;
    },
    onColumnDragEnd(
      { oldIndex, newIndex }:
      { oldIndex: number, newIndex: number },
    ) {
      // move all rows except the header row
      this.$emit('input', (
        this.value.map((
          row: string[],
          index: number,
        ) => {
          if (index !== 0) {
            row.splice(newIndex, 0, row.splice(oldIndex, 1)[0]);
            return row;
          }
          return row;
        })
      ));
    },
    removeColumn(index: number) {
      this.$emit('input', (
        this.value.map((value: any) => [
          ...value.slice(0, index),
          ...value.slice(index + 1),
        ])
      ));
    },
  },
  components: {
    Draggable,
    GridColumn,
    GridTable,
    ShowGuide,
  },
} as IView;
